/**
 * Aramco environment flag.
 *
 * When true, "coming soon" tooltip text is hidden (items remain greyed out
 * and non-interactive) and the Digital Coworker feature is disabled.
 *
 * Detected automatically by checking whether the app hostname contains ".ksa-ar."
 * (e.g. https://app.ksa-ar.intuigence.ai/).
 */
export const isAramcoEnv = typeof window !== 'undefined' && window.location.hostname.includes('.ksa-ar.')
